import dayjs from "dayjs";
import requests from "./httpService";

const TicketService = {
     getAllTicket: async () =>{
        return requests.get("/ticket/all");
     },
     getTicketById: async (id, body) =>{
        return requests.get(`/ticket/${id}`, body);
     },
     UpdateTicketById: async (id, body) =>{
        return requests.put(`/ticket/${id}`, body);
     },
     addTicket: async (body) =>{
        return requests.post("/ticket/add", body);
     },
     deleteTicketById: async (id) =>{
        return requests.delete(`/ticket/${id}`);
     },
     getAllClientTicket: async ({projectId, fromDate, toDate, page, limit }) =>{
      if(fromDate !== "" && fromDate !== 'undefined'){
                  const fromTime = fromDate;
                  var startTime=fromTime.replace("T", " ")
                  startTime = dayjs(startTime).format("YYYY-MM-DD HH:mm:ss");
              }  
              if(toDate !== "" && toDate !== 'undefined'){ 
                  const toTime = toDate +"23:59:59"; 
                  var endTime=toTime.replace("T", " ")
                  endTime = dayjs(endTime).format("YYYY-MM-DD HH:mm:ss");
              }  
        return requests.get(`/clientPortal/ticket/all?project=${projectId}&startDate=${startTime}&endDate=${endTime}&page=${page}&limit=${limit}`);
     },
      getClientTicketById: async (id, body) =>{
        return requests.get(`/clientPortal/ticket/${id}`, body);
     },
     UpdateClientTicketById: async (id, body) =>{
        return requests.put(`/clientPortal/ticket/${id}`, body);
     },
     addClientTicket: async (body) =>{
        return requests.post("/clientPortal/ticket/add", body);
     },
}

export default TicketService;